'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name stickyHeaderBar
    * @description Initializes sticky heading link bar
    **/

    var initialize = function () {
        $(window).on('scroll', function () {
            var scroll = $(window).scrollTop();
            var headerScrollOffset = $('header[role="banner"]').height() + $('nav#primaryNav').height();
            if (scroll >= headerScrollOffset) {
                $('#pageWrapper #topNav').attr('data-anchored', true);
            } else {
                $('#pageWrapper #topNav').attr('data-anchored', false);
                $('header[role="banner"], nav#primaryNav').removeClass('fixed');
                if ($('.hamburger i').hasClass('fa-close')) {
                    $('.hamburger i').removeClass('fa-close');
                    $('.hamburger i').addClass('fa-bars');
                }
            }
        });
    }

    return {
        initialize: initialize
    };
}())